import CardInformacao from './CardInformacao';

export default CardInformacao;
